import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';

import { Observable } from 'rxjs';

import { URL_SERVICIOS } from '../config/config';

@Injectable()
export class CacheWebInterceptor implements HttpInterceptor {

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Solo intervenir llamadas hacia nuestro backend
    if (!req.url.startsWith(URL_SERVICIOS)) {
      return next.handle(req);
    }

    const cacheWeb = this.getCacheWebParam();

    // Si no existe o no es un valor válido,
    // continuar petición normalmente
    if (!cacheWeb) {
      return next.handle(req);
    }

    const valor = cacheWeb.toLowerCase().trim();

    if (valor !== 'true' && valor !== 'saltar') {
      return next.handle(req);
    }

    // Evitar duplicarlo si la llamada ya lo trae
    if (
      req.params.has('cache_web') ||
      /[?&]cache_web=/.test(req.urlWithParams)
    ) {
      return next.handle(req);
    }

    const requestModificado = req.clone({
      setParams: {
        cache_web: valor
      }
    });

    return next.handle(requestModificado);
  }


  /**
   * Obtiene cache_web desde la URL del navegador.
   *
   * Soporta:
   *
   * https://dominio.cl/?cache_web=true#/dashboard
   *
   * y
   *
   * https://dominio.cl/#/dashboard?cache_web=true
   */
  private getCacheWebParam(): string | null {

    // ------------------------------------------
    // 1. Query normal antes del #
    // ------------------------------------------

    const searchParams = new URLSearchParams(
      window.location.search
    );

    const normalParam = searchParams.get('cache_web');

    if (normalParam) {
      return normalParam;
    }


    // ------------------------------------------
    // 2. Query dentro del hash de Angular
    // ------------------------------------------

    const hash = window.location.hash;

    if (!hash) {
      return null;
    }

    const queryIndex = hash.indexOf('?');

    if (queryIndex === -1) {
      return null;
    }

    const hashQuery = hash.substring(queryIndex + 1);

    const hashParams = new URLSearchParams(hashQuery);

    return hashParams.get('cache_web');
  }
}